// Кеш промисов по URL: предзагрузка после получения списка и показ модалки ждут одну загрузку.
const cache = new Map<string, Promise<boolean>>()

export function preloadImage (url: string): Promise<boolean> {
  let promise = cache.get(url)
  if (!promise) {
    promise = new Promise<boolean>(resolve => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const img = new (window as any).Image()
      img.addEventListener('load', () => resolve(true))
      img.addEventListener('error', () => resolve(false))
      img.src = url
    })
    cache.set(url, promise)
  }
  return promise
}

export function clearImageCache (): void {
  cache.clear()
}
